<template>
  <van-tabbar route fixed>
    <van-tabbar-item to="/home" v-if="isUnlogin">
      <img
        slot="icon"
        slot-scope="props"
        :src="props.active ? icons.home.active : icons.home.normal"
      >
      <span>首页</span>
    </van-tabbar-item>
    <!-- 老师 tab 下线 
    <van-tabbar-item to="/strategylist">
      <img
        slot="icon"
        slot-scope="props"
        :src="props.active ? icons.mall.active : icons.mall.normal"
      >
      <span>
        老师
      </span>
    </van-tabbar-item>
    -->
    <van-tabbar-item to="/jsyl">
      <img
        slot="icon"
        slot-scope="props"
        :src="props.active ? icons.jsyl.active : icons.jsyl.normal"
      >
      <span>
        问答
      </span>
    </van-tabbar-item>
    <van-tabbar-item to="/user">
      <img
        slot="icon"
        slot-scope="props"
        :src="props.active ? icons.user.active : icons.user.normal"
      >
      <span>
        我的
      </span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem } from 'vant'
import { islogin, logout } from '@/api/theApi'

Vue.use(Tabbar).use(TabbarItem)

export default {
  name: 'Bottom',
  props: {
    unlogin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      icons: {
        home: {
          name: '首页',
          active: 'https://static.ainvestcn.com/h5/icon/home-icon-a.png',
          normal: 'https://static.ainvestcn.com/h5/icon/home-icon.png'
        },
        /*
        mall: {
          name: '投顾商城',
          active: 'https://static.ainvestcn.com/h5/icon/shop-icon-a.png',
          normal: 'https://static.ainvestcn.com/h5/icon/shop-icon.png'
        },
        */
        user: {
          name: '用户中心',
          active: 'https://static.ainvestcn.com/h5/icon/user-icon-a.png',
          normal: 'https://static.ainvestcn.com/h5/icon/user-icon.png'
        },
        jsyl: {
          name: '金声玉亮',
          active: 'https://static.ainvestcn.com/icon/weixin-s.png',
          normal: 'https://static.ainvestcn.com/icon/weixin-s.png'
        }
      },
      isUnlogin: true,
      active: 0
    }
  },
  created() {
    this.checkLoginStatus()
    // 监听 localStorage 变化
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    async checkLoginStatus() {
      const isloginRes = await islogin()
      const username = localStorage.getItem('username')

      if (isloginRes.login_status && username) {
        this.isUnlogin = false
      } else {
        this.isUnlogin = true
      }

      if (!isloginRes.login_status && username) {
        this.isUnlogin = true
        localStorage.clear()
      }

      if (isloginRes.login_status && !username) {
        this.isUnlogin = true
        await logout()
      }
    },
    handleStorageChange(e) {
      if (e.key === 'username') {
        this.checkLoginStatus()
      }
    }
  },
  watch: {
    unlogin: {
      immediate: true,
      handler(newVal) {
        this.isUnlogin = newVal
      }
    }
  }
}
</script>
